var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('widget-grid-layout'),(_vm.showCoachMark_)?_c('div',[_c('coach-mark')],1):_c('div',{staticClass:"widget add-widget-button",on:{"click":_vm.toggleWidgetSide}},[_c('span',{staticClass:"sf-icon icon-sf-plus"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }